import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { ValueMapper } from './question-types';

@Injectable({
  providedIn: 'root'
})
export class QuestionUtilsService {
  getFilteredOptions$<T>(
    options$: Observable<T[]>,
    search$: Observable<string>,
    labelMapper: ValueMapper<T>
  ): Observable<T[]> {
    return options$.pipe(
      mergeMap(options =>
        search$.pipe(
          map(search => (search || '').toLowerCase()),
          map(search =>
            options.filter(option => {
              const label = this.getValue(option, labelMapper) || '';
              return label.toLowerCase().includes(search);
            })
          )
        )
      )
    );
  }

  getValue<T>(option: T, mapper: ValueMapper<T>): string | null {
    if (!option || !mapper) {
      return null;
    }

    switch (typeof mapper) {
      case 'string':
        return option[mapper];
      case 'function':
        return mapper(option);
      default:
        return `${option}`;
    }
  }
}
